<template>
  <div>
    <h1 class="page-header">{{ $t('infoinquiry.infoinquiry') }}</h1>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-5">
            <div class="ts-flex">
              <div class="ts-flex justify-content-start">
                <ts-button
                  color="info"
                  outline
                  @click="$router.push({ name: 'info-inquiry-create' })"
                >
                  {{ $t('add_new') }}
                </ts-button>
                <div class="col-sm-6">
                  <a-range-picker
                    :allowClear="false"
                    format="DD-MM-YYYY"
                    :defaultValue="rangeDate"
                    :defaultPickerValue="rangeDate"
                    @change="dateRangeChange"
                  >
                    <template slot="renderExtraFooter"></template>
                  </a-range-picker>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-7 d-flex justify-content-end">
            <label class="mt-2 mr-2">{{ $t('infoinquiry.registeredStatus') }} :</label>
            <a-select
              v-model="is_registered"
              style="width: 120px"
              class="ts-mr-2"
            >
              <a-select-option :value="null">All</a-select-option>
              <a-select-option :value="true">Yes</a-select-option>
              <a-select-option :value="false">No</a-select-option>
            </a-select>
            <a-tooltip placement="top">
              <template #title>
                <span>{{ $t('infoinquiry.search') }}</span>
              </template>
              <ts-input
                v-model="search"
                :placeholder="$t('search')"
                style="width: 300px"
                class="mr-2"
              />
            </a-tooltip>

            <ts-button
              outline
              v-tooltip="$t('filter')"
              @click.prevent="visible = true"
            >
              <i class="fa fa-filter"></i>
            </ts-button>
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :rowGroup="{
            field: 'acps_name_foreign'
          }"
        >
          <template v-slot="{ record }">
            <td>
              {{ record.branch !== null ? record.branch.branch_name_en : '' }}
            </td>
            <td>{{ record.inquiry_date }}</td>
            <td>{{ record.full_name_en }}</td>
            <td class="text-center">
              {{ record.gender }}
            </td>
            <td class="text-center">
              {{ record.date_of_birth }}
            </td>
            <td>{{ record.contact_name }}</td>
            <td>{{ record.contact_number }}</td>
            <td>{{ record.email }}</td>
            <td class="text-center">
              <span class="badge badge-success" v-if="record.is_registered"
                >Yes</span
              >
              <span class="badge badge-default" v-else>No</span>
            </td>
            <td>{{ record.from_school }}</td>
            <td class="text-center">
              <a
                href="#"
                v-tooltip="'Edit'"
                class="mr-2 text-primary"
                @click.prevent="edit(record)"
              >
                <i class="fas fa-edit"></i>
              </a>
              <a
                href="#"
                v-tooltip="'Delete'"
                class="text-danger"
                @click.prevent="destroy(record)"
                :disabled="record._deleting"
              >
                <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                <i class="fas fa-trash" v-else></i>
              </a>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-between align-items-center p-15">
        <ts-total-list v-model="pagination" />
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
    <a-drawer
      :title="$t('filter')"
      placement="right"
      :closable="false"
      :visible="visible"
      @close="() => (visible = false)"
      :zIndex="1020"
      width="300px"
    >
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <a-select
              style="width: 257px"
              v-model="branch_id"
              :options="branchs"
              showSearch
              mode="multiple"
              :filterOption="
                (input, option) =>
                  option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
              "
              :maxTagCount="1"
              :maxTagTextLength="17"
              :placeholder="$t('all')"
            >
            </a-select>
          </div>
        </div>
      </div>
    </a-drawer>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'info-inquiry',
  data () {
    return {
      loading: false,
      visible: false,
      branchs: [],
      rangeDate: [moment(), moment()]
    }
  },
  created () {
    this.branch_id = [this.$store.state.authUser.default_branch_id]
    this.fetchData()
    this.getBranch()
  },
  computed: {
    ...mapState('infoInquiry', ['resources', 'pagination']),
    search: {
      get () {
        return this.$store.state.infoInquiry.search
      },
      set (newValue) {
        this.$store.commit('infoInquiry/SET_SEARCH', newValue)
        this.$store.commit('infoInquiry/RESET_CURRENT_PAGE')
      }
    },
    columns () {
      return [
        { name: this.$t('infoinquiry.branch'), style: 'width: 10%' },
        { name: this.$t('infoinquiry.date') },
        { name: this.$t('infoinquiry.nameEN') },
        {
          name: this.$t('infoinquiry.gender'),
          style: 'text-align:center; width: 3%'
        },
        {
          name: this.$t('infoinquiry.dateofBirth'),
          style: 'text-align:center; width: 15%'
        },
        { name: this.$t('infoinquiry.guardian'), style: 'width: 12%' },
        { name: this.$t('infoinquiry.phone'), style: 'width: 6%' },
        { name: this.$t('infoinquiry.email'), style: 'width: 6%' },
        {
          name: this.$t('infoinquiry.registered'),
          style: 'text-align:center; width: 6%'
        },
        { name: this.$t('infoinquiry.fromSchool') },
        {
          name: this.$t('infoinquiry.actions'),
          style: 'text-align:center; width: 100px'
        }
      ]
    },
    date_from: {
      get () {
        return this.$store.state.infoInquiry.date_from
      }
    },
    date_to: {
      get () {
        return this.$store.state.infoInquiry.date_to
      }
    },
    is_registered: {
      get () {
        return this.$store.state.infoInquiry.is_registered
      },
      set (newValue) {
        this.$store.commit('infoInquiry/SET_IS_REGISTERED', newValue)
      }
    },
    branch_id: {
      get () {
        return this.$store.state.infoInquiry.branch_id
      },
      set (newValue) {
        this.$store.commit('infoInquiry/SET_BRANCH_ID', newValue)
      }
    }
  },
  methods: {
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch(
          'infoInquiry/fetch',
          Object.assign(
            {
              branch_id: this.branch_id
            },
            { ...attributes }
          )
        )
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    getBranch () {
      this.$store
        .dispatch('user/getBranch', {
          filter: {
            user_branches: true
          }
        })
        .then(response => {
          this.branchs = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
    },
    dateRangeChange (dateRange) {
      this.$store.commit(
        'infoInquiry/SET_DATE_FROM',
        dateRange[0].format('DD-MM-YYYY')
      )
      this.$store.commit(
        'infoInquiry/SET_DATE_TO',
        dateRange[1].format('DD-MM-YYYY')
      )
      this.fetchData()
    },
    edit (record) {
      this.$store.commit('infoInquiry/SET_FOUND_DATA', record)
      this.$router.push({
        name: 'info-inquiry-edit',
        params: { id: record.inquiry_id }
      })
    },
    show (record) {
      this.$store.commit('infoInquiry/SET_FOUND_DATA', record)
      this.$router.push({
        name: 'info-inquiry-show',
        params: { id: record.inquiry_id }
      })
    },
    async destroy (record) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        record._deleting = true
        this.$store
          .dispatch('infoInquiry/destroy', record.inquiry_id)
          .then(response => {
            this.fetchData()
            if (
              response.message ===
              'Action fail. Inquiry already convert to profile!'
            ) {
              this.$toasted.info(response.message)
            } else {
              this.$toasted.success(response.message)
            }
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500),
    branch_id: debounce(function (value) {
      this.fetchData({ branch_id: value })
    }, 500),
    is_registered: debounce(function (value) {
      this.fetchData({ is_registered: value })
    }, 500)
  },
  beforeRouteLeave (to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'info-inquiry-create') {
      this.$store.commit('infoInquiry/RESET_STATE')
      this.$store.commit('infoInquiry/SET_NATIONALITIES', [])
      this.$store.commit('infoInquiry/SET_MAIN_PROGRAMS', [])
      this.$store.commit('infoInquiry/SET_SUB_PROGRAMS', [])
      this.$store.commit('infoInquiry/SET_STUDY_TIMES', [])
      this.$store.commit('infoInquiry/SET_PROVINCES', [])
      this.$store.commit('infoInquiry/SET_DISTRICTS', [])
      this.$store.commit('infoInquiry/SET_COMMUNES', [])
      this.$store.commit('infoInquiry/SET_VILLAGES', [])
      console.log('ss')
    }
    next()
  }
}
</script>
